import moment from "moment";
import axios from "axios";
import { API_CANAL, API_CANAL_AMI, API_NUEVO_CANAL, API_ONE_STEP } from "../utils/consts";

const widthScreen = window.screen.width;

const formatNumberToDecimal = (number) => {
  if (number < 10 && number > 0) {
    return "0" + number;
  } else {
    return number;
  }
};

const getSession = () => {
  return JSON.parse(localStorage.getItem("currentUser"));
};
const isApp = () => {
  try {
    let url = extractHostname(window.location.href);
    url = url.pathname.replace(".html", "");
    return url.substring(url.length - 3) === "app";
  } catch (error) {
    return null;
  }
};

const converterRequest = (data, type = "") => {
  let formatRequest;
  switch (type) {
    case API_NUEVO_CANAL:
      formatRequest = {
        // headers: getHeaders(type),
        body: {
          payload: {
            request: {
              trace: getTrace("API_CANAL"),
              payload: data,
            },
          },
        },
      };
      break;
    case API_CANAL_AMI:
    case API_CANAL:
      formatRequest = {
        body: {
          trace: getTrace(type),
          payload: data,
        },
      };
      break;
    case API_ONE_STEP:
      formatRequest = {
        body: {
          payload: data,
        },
      };
      break;
    default:
      formatRequest = Object.assign(data);
      break;
  }

  return formatRequest;
};

const getBody = (data, trace) => ({
  body: {
    request: {
      trace: trace || getTrace(),
      payload: data,
    },
  },
});

/* const getHeaders = (type) => {
    let headers;
    switch (type) {
        case API_NUEVO_CANAL:
            headers = {
                'Content-Type': 'application/json',
                'x-api-key': '125THE7YFR510TD2756',
                'traceId': String((new Date()).getTime()),
                'dateTime': new Date().toISOString()
            }
            break;
        default:
            headers = {
                'Content-Type': 'application/json',
            }
            break;
    }

    return headers;
} */

const getBodyAmplify = (data) => ({
  body: {
    request: {
      trace: getTrace(),
      payload: data,
    },
  },
  // headers: {
  //   'id-client': getIdClient(),
  // }
});

const getTrace = (serviceId) => ({
  serviceId: "API-CANAL",
  consumerId: "ZUM",
  channelCode: "WEB",
  traceId: String(new Date().getTime()),
  // traceId: '6b10480f-af20-4676-a8e0-1df84dd7cdb6'
});

const formattingDate = (date) =>
  new Date(moment(date, "DD/MM/YYYY").format("MM/DD/YYYY HH:mm:ss"));

const downloadFile = (response, type, name, document) => {
  const binary = atob(response.replace(/\s/g, ""));
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([view], { type });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

function downloadPdf(response, type, name, document) {
  if (response.status) {
    const blob = new Blob([response.payload], {
      type: type,
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

const formattingPaymentDate = (date) =>
  moment(new Date(date)).format("DD/MM/YY");

const formattingNumber = (number) => {
  const s = `${number}`;
  if (s.length < 2) {
    return `0${s}`;
  }
  return s;
};

const zerofill = (n) => (n < 10 ? `0${n}` : n);

const urlSearch = (name) => {
  const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(
    window.location.href
  );

  if (results == null) {
    return null;
  }
  return decodeURI(results[1]) || 0;
};

const getLocalstorage = (key) => JSON.parse(localStorage.getItem(key));

const handlerErrors = (error) => {
  let notification = {};
  switch (error.httpCode) {
    case 500:
      notification = {
        title: "¡Error Interno!",
        messages:
          error.messages && error.messages[0]
            ? error.messages[0]
            : "Ocurrió un error desconocido",
        type: "error",
      };
      break;
    case 400:
      notification = {
        title: "¡Solicitud Incorrecta!",
        messages:
          error.messages && error.messages[0]
            ? error.messages[0]
            : "Ocurrió un error en la petición",
        type: "error",
      };
      break;
    default:
      notification = {
        title: "¡Sucedió algo!",
        messages: "Ha ocurrido un problema. Intente nuevamente",
        type: "error",
      };
      break;
  }
  return notification;
};

const addQueryString = (url, queryString) => {
  if (queryString) {
    let isQuestionMarkPresent = url && url.indexOf("?") !== -1,
      separator = isQuestionMarkPresent ? "&" : "?";
    url += separator + queryString;
  }
  return url;
};

const removeDuplicateByAtributte = (array, attribute) => {
  const unique = array
    .map((e) => e[attribute])
    .map((e, i, final) => final.indexOf(e) === i && i)
    .filter((e) => array[e] && array[e][attribute])
    .map((e) => array[e]);
  return unique;
};

const formattingAlertDate = (date) =>
  moment(new Date(date)).locale("es").format("LL");

/*
 source: https://es.stackoverflow.com/questions/48958/redondear-a-dos-decimales-cuando-sea-necesario

 1. Adaptado de MDN (solución recomendada)
 Tomando el código de Redondeo Decimal, adapté la solución para que realice un redondeo aritmético simétrico con números negativos. Es decir que redondee -1.5 ≈ -2.
 * */
const round = (num, decimales = 1) => {
  let signo = num >= 0 ? 1 : -1;
  num = num * signo;
  if (decimales === 0)
    //con 0 decimales
    return signo * Math.round(num);
  // round(x * 10 ^ decimales)
  num = num.toString().split("e");
  num = Math.round(
    +(num[0] + "e" + (num[1] ? +num[1] + decimales : decimales))
  );
  // x * 10 ^ (-decimales)
  num = num.toString().split("e");
  return signo * (num[0] + "e" + (num[1] ? +num[1] - decimales : -decimales));
};

/*
 2. Utilizando Intl.NumberFormat()
 La función Intl.NumberFormat([locales[, options]]) permite redondear un número correctamente con código nativo. Sin embargo,
 como se verá más adelante, esta función acepta opciones sensibles al idioma, haciéndola significativamente más lenta.
 * */
const roundWithComma = (numero, decimales = 2, usarComa = false) => {
  let opciones = {
    maximumFractionDigits: decimales,
    useGrouping: false,
  };
  usarComa = usarComa ? "es" : "en";
  return new Intl.NumberFormat(usarComa, opciones).format(numero);
};

/*
 Link: http://jsfiddle.net/jacobuid/ezbao2a3/
 * */

const addComma = (num) => {
  let str = num.toString().split(".");
  if (str[0].length >= 4) {
    //add comma every 3 digits befor decimal
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  }
  /* Optional formating for decimal places
  if (str[1] && str[1].length >= 4) {
      //add space every 3 digits after decimal
      str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }*/
  return str.join(".");
};

/*
 Stackoverflow: Add commas or spaces to group every three digits
 Link: https://stackoverflow.com/a/41719125
 * */
const addCommasAndPoint = (num = null) => {
  if (!num) return num;
  let tempNumber = num.toFixed(2).split(".");
  let tempNumberLeft = tempNumber[0] || "0";
  let tempNumberRight = tempNumber[1] || "0";
  let temp = addComma(num);
  // 1234567.890123 will equal to 1,234,567.890 123

  let divideNumber = (temp + "").split(".");
  let numberLeft = divideNumber[0] || "0";
  let numberRight = divideNumber[1] || "0";

  if (parseFloat(tempNumberLeft) === 0) {
    numberLeft = "0";
  }

  if (parseFloat(tempNumberRight) === 0) {
    numberRight = "00";
  } else {
    let tempNumberWithZeros = parseFloat("0." + numberRight)
      .toFixed(2)
      .split(".");
    numberRight = tempNumberWithZeros[1];
  }

  return `${numberLeft}.${numberRight}`;
};

/*
 * Link: https://www.jacklmoore.com/notes/rounding-in-javascript/
 * */

const extractHostname = (url) => {
  const match = url.match(
    /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
  );
  return (
    match && {
      href: url,
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7],
    }
  );
};
const roundTo = (value, decimals = 2) => {
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

const eventFire = (el, etype) => {
  if (el.fireEvent) {
    el.fireEvent("on" + etype);
  } else {
    let evObj = document.createEvent("Events");
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
};

const mouseClickEvents = ["mousedown", "click", "mouseup"];
const simulateMouseClick = (element) => {
  mouseClickEvents.forEach((mouseEventType) =>
    element.dispatchEvent(
      new MouseEvent(mouseEventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1,
      })
    )
  );
};

// convert the input array to camel case
const toCamelCase = (str) => {
  return str
    .replace(/\s(.)/g, function ($1) {
      return $1.toUpperCase();
    })
    .replace(/\s/g, "")
    .replace(/^(.)/, function ($1) {
      return $1.toLowerCase();
    });
};

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

const ellipsis = function (str, size) {
  let defaultValue = str;
  if (typeObject(str) === "String" && str.length > size) {
    let names = str.toString().split(" ");
    if (Array.isArray(names)) {
      defaultValue = names[0];
      if (defaultValue.length > size) {
        defaultValue = defaultValue.substring(0, size - 1).concat("...");
      }
    }
  }
  return defaultValue;
};

const completeLink = function (str) {
  let defaultValue = str;
  let htmlExtension = ".html";
  if (typeObject(str) === "String" && !str.includes(htmlExtension)) {
    defaultValue = defaultValue.concat(htmlExtension);
  }
  return defaultValue;
};

const typeObject = (value) => {
  let stringConstructor = "test".constructor;
  let arrayConstructor = [].constructor;
  let objectConstructor = {}.constructor;

  function whatIsIt(object) {
    if (object === null) {
      return "null";
    }
    if (object === undefined) {
      return "undefined";
    }
    if (object.constructor === stringConstructor) {
      return "String";
    }
    if (object.constructor === arrayConstructor) {
      return "Array";
    }
    if (object.constructor === objectConstructor) {
      return "Object";
    }
    {
      return "don't know";
    }
  }

  return whatIsIt(value);
};

const getAsJson = (value) => {
  if (typeObject(value) === "Object") {
    return value;
  } else if (typeObject(value) === "String") {
    if (value.charAt(0) === "[" && value.charAt(value.length - 1) === "]") {
      return JSON.parse(value);
    } else if (
      value.charAt(0) === "{" &&
      value.charAt(value.length - 1) === "}"
    ) {
      return JSON.parse(value);
    } else {
      return {};
    }
  } else if (typeObject(value) === "Array") {
    return value;
  } else {
    return {};
  }
};

const capitalizeString = (names) => {
  let namesCapitalize = "";

  if (Array.isArray(names)) {
    namesCapitalize = names.map(
      (name) => name.charAt(0) + name.slice(1).toLowerCase()
    );
    return namesCapitalize.join(" ");
  }

  return (namesCapitalize = names.charAt(0) + names.slice(1).toLowerCase());
};

const getTemplateHtmlFromAEM = function (pathAEM) {
  if (pathAEM) {
    return new Promise((resolve, reject) => {
      const url = window.location.href;
      const arr = url.split("/");
      const domain = arr[0] + "//" + arr[2];
      axios
        .get(domain + pathAEM)
        .then((template) => {
          resolve(template.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const wordsUpperCase = function (str) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
};

const trackResetPasswordCompleted = () => {
  window.digitalData.push({
    event: "trackResetPasswordCompleted",
  });
};

const calcularEdad = (fecha) => {
  var hoy = new Date();
  var cumpleanos = new Date(fecha);
  var edad = hoy.getFullYear() - cumpleanos.getFullYear();
  var m = hoy.getMonth() - cumpleanos.getMonth();

  if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
    edad--;
  }

  return edad;
};

const changeFinalizadoValueOnLead = (leadData, value) => {
  const newLeadData = { ...leadData };
  return { ...newLeadData, ...value };
};
//Tagging Scripts
const getTagApplication = (product, number, leadid, event) => {
  return window.digitalData.push({
    application: {
      product,
    },
    plate: {
      number,
    },
    contact: {
      leadid,
    },
    event,
  });
};

const getTagVirtual = (name, event) => {
  return window.digitalData.push({
    virtual: {
      name,
    },
    event,
  });
};

const getTagMetadata = (key, value, event) => {
  return window.digitalData.push({
    metadata: {
      key,
      value,
    },
    event,
  });
};
const getTagEvent = (event) => {
  return window.digitalData.push({ event });
};

const getTagError = (code, message, event) => {
  return window.digitalData.push({
    error: {
      code,
      message,
    },
    event,
  });
};

const getTagLog = (message, event) => {
  return window.digitalData.push({
    log: {
      message,
    },
    event,
  });
};

const getTagChannel = (channel, name, event) => {
  return window.digitalData.push({
    form: {
      channel,
      name,
    },
    event,
  });
};

const getTagAction = (group, category, eventAction, label, event) => {
  return window.digitalData.push({
    action: {
      group,
      category,
      label,
      name: eventAction,
    },
    event,
  });
};

const getTagAction2 = (group, category, event1, label, event2) => {
  return window.digitalData.push({
    action: {
      group,
      category,
      label,
      name: event1,
    },
    event: event2,
  });
};

const getTagSnapshot = (data, event) => {
  return window.digitalData.push({
    snapshot: {
      data,
    },
    event,
  });
};

const getTagTransaction = (
  id,
  store,
  revenue,
  coupon,
  products,
  metadata,
  event
) => {
  return window.digitalData.push({
    transaction: {
      id,
      store,
      revenue,
      payment: {
        term: "",
        type: "Tarjeta",
      },
      coupon,
      products,
      metadata,
    },
    event,
  });
};

//Metodos para obtener parametros de campaña
const getParameterValue = (sParametroNombre) => {
  var sPaginaURL = window.location.search.substring(1);
  var sURLVariables = sPaginaURL.split("&");
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParametro = sURLVariables[i].split("=");
    if (sParametro[0] === sParametroNombre) {
      return sParametro[1];
    }
  }
  return null;
};

export const getParameterEmbeddedValue = (sParametroNombre, urlEmbedded) => {
  const sURLVariables = urlEmbedded.split("&");
  for (let i = 0; i < sURLVariables.length; i++) {
    const sParametro = sURLVariables[i].split("=");
    if (sParametro[0] === sParametroNombre) {
      return sParametro[1];
    }
  }
  return null;
};

const convertParametersToArray = (parameter) => {
  const param = getParameterValue(parameter);
  return param.indexOf(":") !== -1 ? param.split(":") : param.split("%3A");
};

const getCampaign = () => {
  var source = "",
    origenCampania = "",
    origenContenido = "",
    origenMedio = "",
    origenTipoPlan = "";
  if (getParameterValue("gclid") != null) {
    source = "Google Adwords";
    if (getParameterValue("origen_fuente") != null) {
      source = getParameterValue("origen_fuente");
    }
    if (getParameterValue("origen_medio") != null) {
      origenMedio = getParameterValue("origen_medio");
    }
    if (getParameterValue("origen_campaign") != null) {
      origenCampania = getParameterValue("origen_campaign");
    }
  } else if (getParameterValue("utm_source") != null) {
    source = getParameterValue("utm_source");
    origenCampania = getParameterValue("utm_campaign");
    origenContenido = getParameterValue("utm_content");
  } else if (getParameterValue("origen_fuente") != null) {
    source = getParameterValue("origen_fuente");
  }

  if (getParameterValue("utm_medium") != null) {
    origenMedio = getParameterValue("utm_medium");
  } else if (getParameterValue("origen_medio") != null) {
    origenMedio = getParameterValue("origen_medio");
  }

  if (null != getParameterValue("tipoplan")) {
    origenTipoPlan = getParameterValue("tipoplan");
  }
  //Regla mcid
  if (getParameterValue("mcid") != null) {
    let arrParameters = convertParametersToArray("mcid");
    source = arrParameters[0];
    origenMedio = arrParameters[1];
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(":");
  }
  //Regla pcid
  if (getParameterValue("pcid") != null) {
    let arrParameters = convertParametersToArray("pcid");
    source = "Internal Campaigns";
    origenMedio = arrParameters.slice(0, 2).join(":");
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(":");
  }
  //Regla rfid
  if (getParameterValue("rfid") != null) {
    let arrParameters = convertParametersToArray("rfid");
    source = "Internal Reference";
    origenMedio = arrParameters.slice(0, 2).join(":");
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(":");
  }

  return {
    source,
    origenCampania,
    origenContenido,
    origenMedio,
    origenTipoPlan,
  };
};

const setTagDigitalID = (id) => {
    return window.digitalData.push({
      audience: {
        id,
        authState: "Authenticated",
      },
      event: "trackAudience",
    });
  };

const setActionTag = ({
  group,
  category,
  action,
  label,
  event = "trackAction",
}) => {
  window.digitalData.push({
    action: {
      group: group,
      category: category,
      name: action,
      label: label,
    },
    event: event,
  });
};

/**
 * Esta funcion es para que sume de 100 en y en el caso que baje menos del monto minimo
 * se bloquee en este, de igual manera en el maximo
 * @param amount el monto actual
 * @param minAmount el monto minimo
 * @param maxAmount el monto maximo
 * @param amountSumOrSub la cantidad a sumar o restar
 * @param isSum define si se suma o se resta, si es {true} suma y si es {false}, resta
 */
const calculateDiscountFlex = (
  amount,
  minAmount,
  maxAmount,
  isSum = true,
  amountSumOrSub = 100
) => {
  amount = Number(amount);
  let curreAmount = isSum ? amount + amountSumOrSub : amount - amountSumOrSub;

  if (curreAmount > maxAmount) {
    curreAmount = maxAmount;
  } else if (curreAmount < minAmount) {
    curreAmount = minAmount;
  }

  return curreAmount;
};

// convierte un string en array !!
const convertStringToArray = (string, separator = ",") => {
  return string.split(separator).map((str) => str.trim());
};

const prepareRequest = (data, path) => {
  return {
    data: converterRequest(data, API_CANAL),
    name: API_CANAL,
    path,
  };
};

/**
 * Esta funcion convierte un objeto en un queryString de url!!
 * @param {Object} data Un Objeto {any}
 */
const queryParse = (data) => {
  if (!data) return data;

  return Object.entries(data).reduce((acc, el) => {
    return !acc ? `?${el[0]}=${el[1]}` : `${acc}&${el[0]}=${el[1]}`;
  }, "");
};

/**
 * Corta un string y lo concatena con "..."
 * @param {string} str El string a ser tratado
 * @param {number} max El maximo de caracterres permitidos
 * @param {string} concatEnd El string que se concatena al final
 */
export const cutCharacters = (str, max = 17, concatEnd = "...") => {
  if (!str) return;

  if (str.length > max) {
    const newStr = str.substr(0, max) + concatEnd;

    return newStr;
  }

  return str;
};

// genera un array con el años actual, y 18 años menos, o el dato que se le envie!!
const arrayYears = (currentYear, subtraction = 18) => {
  if (!currentYear) return [];

  let beginYear = currentYear - subtraction;
  let arrYear = [];

  for (beginYear; beginYear <= currentYear; beginYear++) {
    arrYear.push({ text: beginYear.toString() });
  }

  return arrYear;
};

const generateTraceId = () => new Date().getTime().toString();

//Metodo para validar fecha de nacimiento
const validateBirthday = (day, month, year) => {
  let dayVar = false;
  const today = new Date();
  let monthVar = false;
  let yearVar = false;
  let isValidDay = true;

  if (day.length) {
    dayVar = Number(day) < 32 && !!Number(day);

    if (month.length) {
      let validDay = new Date(Number(year), Number(month), 0).getDate();
      isValidDay = Number(day) <= validDay;
    }
  }

  if (month.length) {
    monthVar = Number(month) <= 12 && !!Number(month);
  }

  if (year.length) {
    yearVar = new RegExp(/^(19|20)\d{2}$/).test(year);
  }

  // if (day.length && month.length && year.length) {
  if (
    day.length &&
    month.length &&
    year.length &&
    Number(today.getFullYear()) <= Number(year)
  ) {
    if (
      !moment(`${year}-${month}-${day}`).isBefore(
        `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
      )
    ) {
      return {
        showError: true,
      };
    }
  }

  return {
    showError:
      (!dayVar && day.length) ||
      (!monthVar && month.length) ||
      (!yearVar && year.length) ||
      !isValidDay,
    day: (!dayVar && day.length) || !isValidDay,
    month: !monthVar && month.length,
    year: !yearVar && year.length,
  };
};

//GET ful date for timestamp
const formatPrice = (num) =>
  num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

const getBeginningValidity = () => {
  return moment().add(1, "day").format("YYYY-MM-DD");
};

// DD/MM/YYYY -> YYYY-MM-DD
const convertirFormatoFecha = (fecha) => {
  if (fecha && typeof fecha !== "string") return "";
  let newFecha = moment(fecha, "DD/MM/YYYY").format();
  return moment(newFecha).format("YYYY-MM-DD");
};

// YYYY-MM-DD -> DD/MM/YYYY
const convertirFormateIIFecha = (fecha) => {
  if (fecha && typeof fecha !== "string") return "";
  let nacimiento = moment(fecha, "YYYY-MM-DD").toDate();
  return moment(nacimiento).format("DD/MM/YYYY");
};

const calculateYearsOld = (yearVehicle) => {
  let year = yearVehicle && parseInt(yearVehicle);
  return new Date().getFullYear() - year;
};

const getFormatMount = (mount) => {
  const newMount = mount.split(".");
  return newMount[0];
};

const getFormatDecimalMount = (mount) => {
  const newMount = mount.split(".");
  if (newMount[1]) {
    if (newMount[1].length == 1) {
      return `${newMount[1]}0`;
    }
    return newMount[1];
  } else {
    return "00";
  }
};

// YHN777 -> YHN-777
// agregarCaracter(placa, "-", 3)
const agregarCaracter = (cadena, caracter, pasos) => {
  let cadenaConCaracteres = "";
  const longitudCadena = cadena.length;
  for (let i = 0; i < longitudCadena; i += pasos) {
    if (i + pasos < longitudCadena) {
      cadenaConCaracteres += cadena.substring(i, i + pasos) + caracter;
    } else {
      cadenaConCaracteres += cadena.substring(i, longitudCadena);
    }
  }
  return cadenaConCaracteres;
};

const handleCalculateExpirationDate = (endDate) => {
  const format = "YYYY-MM-DD";
  const today = moment(moment(), format);
  const momentEndDate = moment(endDate, format);
  const diff = momentEndDate.diff(today, "days");
  return diff + 1;
};

const sleep = (timeout) =>
  new Promise((resolve) => {
    var tm = setTimeout(() => {
      resolve();
      clearTimeout(tm);
    }, timeout);
  });

export const sendMessageToApp = (label) => {
  /* Envío de mensaje android */
  logger.log(label);
  /* Envío de mensaje para ios */
  if (window.webkit) {
    window.webkit.messageHandlers.MessageHandler.postMessage(label);
  }
};
export const logger = {
  log: console.log,
  warn: console.warn,
  //error: console.error,
};

const helpers = {
  getTemplateHtmlFromAEM,
  widthScreen,
  setActionTag,
  getTagAction2,
  changeFinalizadoValueOnLead,
  calcularEdad,
  trackResetPasswordCompleted,
  capitalizeString,
  completeLink,
  ellipsis,
  handlerErrors,
  converterRequest,
  getBody,
  zerofill,
  formattingDate,
  formattingPaymentDate,
  formattingNumber,
  urlSearch,
  getLocalstorage,
  downloadFile,
  addQueryString,
  removeDuplicateByAtributte,
  downloadPdf,
  formattingAlertDate,
  round,
  roundWithComma,
  addCommasAndPoint,
  roundTo,
  addComma,
  eventFire,
  simulateMouseClick,
  toCamelCase,
  capitalize,
  typeObject,
  getAsJson,
  getSession,
  getBodyAmplify,
  isApp,
  extractHostname,
  wordsUpperCase,
  formatNumberToDecimal,
  getTagChannel,
  getTagApplication,
  getTagMetadata,
  getTagEvent,
  getTagError,
  getTagLog,
  getTagAction,
  getTagVirtual,
  getTagSnapshot,
  getTagTransaction,
  getParameterValue,
  getCampaign,
  calculateDiscountFlex,
  convertStringToArray,
  prepareRequest,
  queryParse,
  arrayYears,
  generateTraceId,
  validateBirthday,
  cutCharacters,
  formatPrice,
  getBeginningValidity,
  convertirFormatoFecha,
  convertirFormateIIFecha,
  calculateYearsOld,
  getFormatMount,
  getFormatDecimalMount,
  agregarCaracter,
  handleCalculateExpirationDate,
  sleep,
  sendMessageToApp,
};

export default helpers;
